import { cn } from '@bb/ui'

export interface MetricTileProps {
  label: string
  value: string
  hint?: string
  tone?: 'neutral' | 'accent' | 'danger'
}

/**
 * One figure, plainly stated. §5 asks for honest counts, not trends or
 * ratios — so unlike the customer dashboard's `StatTile`, there is no
 * comparison arrow here to imply one. The serif face and tabular figures
 * are the same idiom that dashboard already uses for its headline numbers,
 * carried over so both applications read as the same product.
 */
export function MetricTile({ label, value, hint, tone = 'neutral' }: MetricTileProps) {
  return (
    <div className="flex min-w-0 flex-col gap-1 px-4 py-3 [container-type:inline-size]">
      <p className="truncate text-xs text-ink-muted" title={label}>{label}</p>
      <p
        className={cn(
          'min-w-0 font-serif tabular font-semibold leading-none break-words text-[clamp(1.125rem,9cqi,2rem)]',
          tone === 'danger' && 'text-danger',
          tone === 'accent' && 'text-accent',
          tone === 'neutral' && 'text-ink',
        )}
      >
        {value}
      </p>
      {hint ? <p className="truncate text-xs text-ink-faint">{hint}</p> : null}
    </div>
  )
}
